import { ca } from '@cian/analytics';

type TListingType = 'to_listing_jk' | 'to_map';

const trackListingLinkClick = (listingType: TListingType) => {
  ca('eventSite', {
    action: 'Click',
    category: 'Promo',
    label: listingType,
    name: 'oldevent',
    useLastProducts: true,
  });
};

export const trackListingUrlClick = () => trackListingLinkClick('to_listing_jk');

export const trackMapUrlClick = () => trackListingLinkClick('to_map');
